import { defineStore } from 'pinia'

export const CurrentDistrict = defineStore('zn_c_district', {
    state: () => {
        return { zn_c_district: null }
    },
    actions: {
        get() {
            return this.zn_c_district
        },
        set(data) {
            this.zn_c_district = data
        }
    },
})
